/* 🤖 this file was generated by svg-to-ts */
export const emperorIconDollarCircle1: {
  name: 'dollar_circle_1';
  data: string;
} = {
  name: 'dollar_circle_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M12 2.003c-5.52 0-10 4.48-10 10 0 5.51 4.48 10 10 10 5.51 0 10-4.49 10-10 0-5.52-4.49-10-10-10Zm3 8h-3.5c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h1c1.37 0 2.5 1.12 2.5 2.5 0 1.2-.86 2.21-2 2.449v1.05h-2v-1H9v-2h3.5c.27 0 .5-.23.5-.5 0-.28-.23-.5-.5-.5h-1c-1.38 0-2.5-1.13-2.5-2.5 0-1.21.86-2.22 2-2.449V6.99h2v1h2v2Z"/></svg>`,
};
